import type { GraphQLError, GraphQLResponse } from 'graphql-request/dist/types';

import type { NotificationButtonAction } from 'src/ui/features/notifications';

type GraphErrorExtensions = {
  button?: NotificationButtonAction;
  code?: string;
};

type GraphQLErrorWithExtensions = GraphQLError & {
  extensions?: GraphErrorExtensions;
};

export type GraphError = {
  response?: GraphQLResponse;
  message: string;
};

export const getErrorFromGraphQL = (error: GraphError) => {
  let { message } = error;
  let button: NotificationButtonAction | undefined;
  let code: string | undefined;

  const errors: GraphQLErrorWithExtensions[] = error.response?.errors || [];
  if (errors.length) {
    message = errors[0].message;
    button = errors[0].extensions?.button;
    code = errors[0].extensions?.code;
  }

  return { message, button, code };
};
